import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import { sellerDeepDiveReportFormIsOpen, sellerDeepDiveSubmittedFilters } from "../@signals"


export default function useMarketplacesSellerDeepDiveReportForm(dataRow={}) {
    const { showToast } = useToast()
    const { userEmail, userCustomer } = useUserApp()

    const nameReport = useSignal('')
    const frequency = useSignal(null)
    const emailsReport = useSignal([userEmail])

    const resetFormData = () => {
        nameReport.value = ''
        frequency.value = null
        emailsReport.value = [userEmail]
    }

    const handleOpenForm = () => {
        sellerDeepDiveReportFormIsOpen.value = true
    }

    const handleSendToBack = () => {
        let apiUrl =`${WEBBACK_V2_API}/reports/create`

        if (frequency.value === 'now') {
            apiUrl = `${WEBBACK_V2_API}/reports/execute-now`
        }

        const payload = {
            nameReport: nameReport.value,
            frequency: frequency.value,
            emailsReport: emailsReport.value.join(","),
            reportType: 'sellerDeepDive',
            filters: {
                country: sellerDeepDiveSubmittedFilters.value.country, retailer: sellerDeepDiveSubmittedFilters.value.retailer,
                brand: sellerDeepDiveSubmittedFilters.value.brand, skuGroup: sellerDeepDiveSubmittedFilters.value.skuGroup,
                sku: sellerDeepDiveSubmittedFilters.value.sku, sellers: sellerDeepDiveSubmittedFilters.value.sellers,
                id_customer: userCustomer
            }
        }

        showToast.promise(postSubmit(apiUrl, payload), {
            error: 'Error: Please try again later.',
            success: `Report successfully created.`,
        })
    }

    return {
        handleOpenForm,
        handleSendToBack,
        resetFormData,
        nameReport: nameReport,
        frequency: frequency,
        emailsReport: emailsReport
    }
}